'use strict';

const counterEl = '.js-animated-counter';
const counterSettings = {
    percLarge: 0.05, // Percentage used for numbers larger then 100
    percSmall: 0.5, // Percentage used for number smaller then or equal to 100
    maxCount: 300
};

const scrollObserver = new IntersectionObserver((tiles) => {
    for (const tile of tiles) {
        if (tile.isIntersecting) {
            const el = tile.target;
            const counterValue = parseInt(el.dataset.counterValue) || 0;
            const unit = el.dataset.counterUnit || '';
            const percentage = counterValue > 100 ? counterSettings.percLarge : counterSettings.percSmall;
            const toCount = Math.min(Math.ceil(counterValue * percentage), counterSettings.maxCount);
            const from = counterValue - toCount;

            startCounter(el, from, counterValue, unit);
            scrollObserver.unobserve(el);
        }
    }
}, {
    threshold: [0.33]
});

/**
 * Creates a changing delay based on the Robbert Penner easing functions.
 * Source: https://github.com/bameyrick/js-easing-functions
 * @param {Number} elapsed Current Number to update Easing with
 * @param {Number} initialValue Initial delay
 * @param {Number} amountOfChange Max delay
 * @param {Number} duration Max Number to update Easing with
 * @returns {Number}
 */
const easeInExpo = (elapsed, initialValue, amountOfChange, duration) => {
    return elapsed === 0 ? initialValue : amountOfChange * Math.pow(2, 10 * (elapsed / duration - 1)) + initialValue;
};

/**
 * Starts observing all counter elements in the DOM
 */
const initObserver = () => {
    document.querySelectorAll(counterEl).forEach((el) => {
        scrollObserver.observe(el);
    });
};

/**
 * Handles the count animation of a given counter element
 * @param {DOM Element} el Counter element to show number in
 * @param {Number} from Start of count
 * @param {Number} to End of count
 * @param {String} unit Unit to append to count like a '%' sign
 */
const startCounter = (el, from, to, unit) => {
    let time = 0;
    const diff = to - from;
    const step = (diff > 100) ? 4 : 1;
    const minTime = 0;
    const maxTime = 5000;

    for (let i = 0; i <= diff; i += step) {
        (function(count, delay) {
            setTimeout(function() {
                el.innerHTML = (from + count).toLocaleString('en-NL') + unit;
            }, delay);
        })(i, time);

        time = easeInExpo(i, minTime, maxTime, diff);
    }
};

/**
 * Check if we should init or not by searching for a selector
 * @returns {Boolean}
 */
 const shouldInit = () => {
    return document.querySelectorAll(counterEl).length > 0;
};

const animatedCounter = {
    init: () => {
        if (shouldInit()) {
            initObserver();
        }
    }
};

module.exports = animatedCounter;
